<template>
<div style="width:100%;text-align:center;">
  <h1>页面未找到</h1>
</div>
</template>

<script>
export default {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/404.vue